import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_wrkrs_free_to_terminate_their_employment_after_their_notice'

export const dataPointDefinition = {
  retracedId: 'are_wrkrs_free_to_terminate_their_employment_after_their_notice',
  name: 'Are workers free to terminate their employment after their notice period and/or contract expiry?',
  description:
    'Even where workers initially agreed to their employment, they must remain free to leave the job. Workers on undetermined duration contracts as well as workers on fixed duration contracts should be free to resign after the legally required notice period has been provided. Workers who resign before the end of a fixed duration contract may be subject to reasonable penalties for early termination in conformance with applicable legal requirements, but they should not be required to continue working for a significant period of time beyond the legally required notice period, or be subject to penalties that are not legally allowed. They also should not be required to work beyond the expiration of their contracts without their consent.\r\r\nAnswer No if workers are not free to leave their employment after providing legally required notice, or they are required to work beyond the term of their contracts and they have not freely consented to do so.\r\r\n\r\r\nConsult applicable legal requirements to determine the legally required notice period, as well as any legally allowed penalties for early termination. If there is no legally required notice period, determine whether workers can terminate their employment with reasonable notice. If there are no legally allowed penalties for early termination, assume that penalties are not acceptable.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fl-15',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17770,
  sectionId: '2.2.7',
  impactArea: 'Forced Labour',
  impactAreaId: 'FORCED_LABOUR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
